module.exports = "<ea-message-inbox-page></ea-message-inbox-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaMessage/eaMessageInbox/eaMessageInboxPage/eaMessageInboxPageModule.html
// module id = 1034
// module chunks = 12